export const cookieConsentName = 'cookie_consent';
export const cookieConsentValue = 'accepted';
export const cookieDonationName = 'cookie_donation';
export const cookieDonationValue = 'hide';
